module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Left_nav_set"
  }, [_vm._l((_vm.routes), function(item) {
    return [(!item.hidden && item.noDropdown && item.children.length > 0) ? _c('router-link', {
      attrs: {
        "to": item.path + '/' + item.children[0].path
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": item.path + '/' + item.children[0].path
      }
    }, [(item.icon) ? _c('i', {
      class: item.icon
    }) : _vm._e(), _vm._v(" " + _vm._s(item.children[0].name) + "\n            ")])], 1) : _vm._e(), _vm._v(" "), (!item.noDropdown && !item.hidden) ? _c('el-submenu', {
      attrs: {
        "index": item.key
      }
    }, [_c('template', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [(item.icon) ? _c('i', {
      class: item.icon
    }) : _vm._e(), _vm._v(" " + _vm._s(item.name) + "\n            ")]), _vm._v(" "), (item.key == 'province_role') ? [_c('el-menu-item-group', [_c('template', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v("审核：")]), _vm._v(" "), _vm._l((item.children), function(child, inx) {
      return (!child.hidden && inx < 3) ? [(child.isShow) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "menu-indent",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        staticClass: "menu-indent",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        style: (_vm.bgSet(child.key)),
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n                                    " + _vm._s(child.name) + "\n                                ")])], 1)] : _vm._e()] : _vm._e()
    })], 2), _vm._v(" "), _c('el-menu-item-group', [_c('template', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v("上报：")]), _vm._v(" "), _vm._l((item.children), function(child, inx) {
      return (!child.hidden && inx >= 3 && inx < 5) ? [(child.isShow) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "menu-indent",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        staticClass: "menu-indent",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        style: (_vm.bgSet(child.key)),
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n                                    " + _vm._s(child.name) + "\n                                ")])], 1)] : _vm._e()] : _vm._e()
    })], 2), _vm._v(" "), _c('el-menu-item-group', [_c('template', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v("登记：")]), _vm._v(" "), _vm._l((item.children), function(child, inx) {
      return (!child.hidden && inx >= 5 && inx < 8) ? [(child.isShow) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "menu-indent",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        staticClass: "menu-indent",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        style: (_vm.bgSet(child.key)),
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n                                    " + _vm._s(child.name) + "\n                                ")])], 1)] : _vm._e()] : _vm._e()
    })], 2), _vm._v(" "), _c('el-menu-item-group', [_c('template', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v("查询：")]), _vm._v(" "), _vm._l((item.children), function(child, inx) {
      return (!child.hidden && inx >= 8) ? [(child.isShow) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "menu-indent",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        staticClass: "menu-indent",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        style: (_vm.bgSet(child.key)),
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n                                    " + _vm._s(child.name) + "\n                                ")])], 1)] : _vm._e()] : _vm._e()
    })], 2)] : [_vm._l((item.children), function(child, inx) {
      return (!child.hidden) ? [(child.isShow) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "menu-indent",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        staticClass: "menu-indent",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        style: (_vm.bgSet(child.key)),
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n                                " + _vm._s(child.name) + "\n                            ")])], 1)] : _vm._e()] : _vm._e()
    })]], 2) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b48379f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/SidebarItem.vue
// module id = 1714
// module chunks = 1